import React from 'react';
export const formatStringMessage = (message, variables) => formatMessage(message, variables).filter(assertString).join('');
export const formatReactMessage = (message, variables) => /*#__PURE__*/React.createElement(React.Fragment, null, formatMessage(message, variables).map((e, i) => /*#__PURE__*/React.createElement(React.Fragment, {
  key: i
}, e)));
export const formatMessage = (message, variables) => message.split(/({[A-z]*})/g).map(getVariableValues(variables)).reduce(concatStringsReducer, []);
const getVariableValues = variables => input => {
  const variableName = input.slice(1, -1);
  const variableValue = variables === null || variables === void 0 ? void 0 : variables[variableName];
  return variableValue === undefined ? input : variableValue;
};
const concatStringsReducer = (accumulator, current) => {
  const [previous, ...rest] = [...accumulator].reverse();
  if (typeof current === 'string' && typeof previous === 'string') {
    return [`${previous}${current}`, ...rest].reverse();
  }
  return [...accumulator, current];
};
const assertString = s => typeof s === 'string';